import {
  SET_USER_INTENT_PROMPT,
  SET_SALES_FORCE_PROCESSED,
} from 'actions/userIntent';

const defaultState = {
  promptVisible: false,
  isSalesForceProcessed: false,
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case SET_USER_INTENT_PROMPT:
      return {
        ...state,
        promptVisible: action.meta.visible,
      };
    case SET_SALES_FORCE_PROCESSED:
      return {
        ...state,
        isSalesForceProcessed: action.meta.isProcessed,
      };
    default:
      return state;
  }
};
